import { Vector2 } from '@babylonjs/core/Maths/math';

import { MeshSystem } from '../System/meshSystem';
import { GravityGrid } from '../System/gravityGrid';
import { minSize, maxSize, startSize } from '../Objects/star';
import { Player } from './player';
import { PlanetMap } from '../Map/planetMap';
import { MovingEntity } from '../Entity/movingEntity';

export class IAPlayer extends Player {

    ia = true;

    constructor(system: MeshSystem, gravityGrid: GravityGrid, planetMap: PlanetMap) {
        super(system, gravityGrid, planetMap, { temperature: 5000, maxPlanet: 5 });
        
        let random = Math.pow(Math.random(), 3);
        let size = startSize + random * (maxSize - minSize);
        this.setSize(size);
    }

    level = 1;
    setLevel(level: number) {
        this.level = 1 - (level / 10);
    }

    smart(): boolean {
        return Math.random() > this.level;
    }

    checkAction(closestTarget: Player, closestAbsorber: Player) {
        if (this.absorber) {
            if (this.smart()) this.avoidAbsorption(this.absorber, true);
        } else if (this.target) {
            if (this.smart()) this.goToPlayer(this.target);
        } else if (closestTarget && closestAbsorber) {
            let distTarget = Vector2.Distance(this.position, closestTarget.position);
            let distAbsorber = Vector2.Distance(this.position, closestAbsorber.position);
            if (distAbsorber > distTarget) {
                if (this.smart()) this.avoidAbsorption(closestAbsorber, false);
            } else {
                if (this.smart()) this.goToPlayer(closestTarget);
                else this.moveAround();
            }
        } else {
            this.moveAround();
        }
    }

    movingAround = false;
    moveAround() {
        if (!this.movingAround) {
            this.movingAround = true;
            let move = new Vector2((Math.random() - 0.5), (Math.random() - 0.5));
            this.moveCatcher.catch(move);
        }
    }

    avoidAbsorption(absorber: MovingEntity, accelerate: boolean) {
        this.movingAround = false;
        let direction = this.position.subtract(absorber.position);
        this.moveBit(direction);
        if (accelerate) this.tryAccelerate()
    }

    goToPlayer(player: Player) {
        this.movingAround = false;
        let move = player.position.subtract(this.position);
        this.moveCatcher.catch(move);
        this.tryAccelerate()
    }

    moveBit(move: Vector2) {
        move.x += (Math.random() - 0.5);
        move.y += (Math.random() - 0.5);
        this.moveCatcher.catch(move);
    }

    tryAccelerate() {
        if (this.smart() && this.satellites.length && !this.accelerating) {
            this.accelerate();
        }
    }

    dispose() {
        this._disposePlayer();
    }

    showIA() {
        if (this.isStarVisible) return;
        this.show();
    }

    hideIA() {
        if (!this.isStarVisible) return;
        this.hide();
    }

}